import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";
import { InstitutionView } from "@bitwarden/web-vault/app/models/view/institution/institution.view";
import { ActionButton } from "@bitwarden/web-vault/app/components/buttons/gloss-button/actionButton";

@Component({
  selector: "app-institution-form",
  templateUrl: "./institution-form.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstitutionFormComponent {
  @Input() institutionView: InstitutionView;
  @Input() saveButtonOptions: ActionButton;
  @Input() countryOptions: string[];
  @Input() institutionOptions: string[];
  @Input() productOptions: string[];
  @Input() institutionName: string;
  @Input() institutionCountry: string;
  @Input() linkedInstitution: string | null;
  @Input() selectedProduct: string | null;
  /** Shared with a team: it can't be linked (#6316), so the link controls give way to a note, with
   * a way to remove an old link still saved (`hasLink`; `linkedInstitution` names it if resolved). */
  @Input() linkUnavailable = false;
  @Input() hasLink = false;
  /** The saved link is cleared in the form: saving removes it (with Undo until then). */
  @Input() linkRemovalPending = false;

  @Output() institutionNameChange = new EventEmitter<string>();
  @Output() institutionCountryChange = new EventEmitter<string>();
  @Output() linkedInstitutionChange = new EventEmitter<string>();
  @Output() linkedProductChange = new EventEmitter<string>();
  @Output() linkCleared = new EventEmitter<void>();
  @Output() linkRestored = new EventEmitter<void>();
}
